import React,{useEffect,useState} from "react";
// import Table from "../Suppliermanagment/Table/Table"; // new
import Table from "./RankingTable/Table/Table";
import { getAuthorization } from "../../../../axios/AxiosAut";

function TableData() {


  const [Data, setData] = useState([]);
  const getTableData = () => {
    getAuthorization()
      .get(`dashboard/customers/list_customer_issues/`)
      .then((res) => {
        console.log("tabel data", res.data.customer_issues
        );
        setData(res.data.customer_issues
          );
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getTableData();
    console.log("Data.....", Data);
  }, []);

  const data = [
    {
      issue: "MRP",
      c_name: "Zeire Gadtid",
      country:"USA",
      report: "13-03-2022",
    },
    {
      issue: "White Light",
      c_name: "Zeire Gadtid",
      country:"Italy",

      report: "13-03-2022",
    },
    {
      issue: "White Light",
      c_name: "Zeire Gadtid",
      country:"USA",

      report: "13-03-2022",
    },
    {
      issue: "MRP",
      c_name: "Zeire Gadtid",
      country:"Canada",

      report: "13-03-2022",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "Client Name",
        accessor: "client_name",
      },
     
      {
        Header: "Country",
        accessor: "client_country",
      },
      {
        Header: "Issue",
        accessor: "name",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      
    ],
    []
  );

  return (
    <div className="mb-4">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-4">
          <Table
            columns={columns}
            data={Data === undefined ? [] : Data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableData;
